import * as React from "react";

import placeholderImg from "assets/img/reports-new/reports-placeholder.svg";
import { NoMobileScreen } from "components/mobile/NoMobileScreen";

const NoMobile: React.FC = () => (
  <NoMobileScreen
    icon={placeholderImg}
    description={
      <>
        <strong>Rules</strong> are not available on mobile devices. Please switch to a desktop browser to manage rules.
      </>
    }
  />
);

export default NoMobile;
